import React from 'react';

function BankGuarantees() {
  const banks = [
    { name: 'Сбербанк', rate: '2.5%', amount: 'до 500 млн ₽', term: 'до 36 месяцев', url: 'https://www.sberbank.ru/ru/legal/bankguarantee' },
    { name: 'ВТБ', rate: '2.8%', amount: 'до 300 млн ₽', term: 'до 24 месяцев', url: 'https://www.vtb.ru/business/bankovskie-garantii/' },
    { name: 'ПСБ', rate: '3.0%', amount: 'до 200 млн ₽', term: 'до 24 месяцев', url: 'https://www.psbank.ru/Business/BankGuarantees' },
    { name: 'Альфа-Банк', rate: '2.7%', amount: 'до 150 млн ₽', term: 'до 12 месяцев', url: 'https://alfabank.ru/sme/bankguarantees/' },
    { name: 'Банк ДОМ.РФ', rate: '2.9%', amount: 'до 100 млн ₽', term: 'до 24 месяцев', url: 'https://банк.дом.рф/business/bankguarantees/' },
  ];

  return (
    <div>
      <h2>Банковские гарантии</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Независимые банковские гарантии для госконтрактов (44-ФЗ, 223-ФЗ, 615-ПП)
      </p>

      <div style={{ marginBottom: 20, padding: 14, background: '#1E293B', borderRadius: 8, border: '1px solid #334155' }}>
        <h3 style={{ marginBottom: 8 }}>Как получить гарантию</h3>
        <ol style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20 }}>
          <li style={{ marginBottom: 4 }}>Выберите банк из списка ниже</li>
          <li style={{ marginBottom: 4 }}>Подготовьте документы: ИНН, финансовая отчётность, проект контракта</li>
          <li style={{ marginBottom: 4 }}>Подайте заявку через сайт банка</li>
          <li style={{ marginBottom: 4 }}>Получите одобрение за 1–5 рабочих дней</li>
          <li>Получите гарантию и загрузите на торговую площадку</li>
        </ol>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Банк</th>
            <th style={{ padding: 8 }}>Ставка</th>
            <th style={{ padding: 8 }}>Сумма</th>
            <th style={{ padding: 8 }}>Срок</th>
            <th style={{ padding: 8 }}>Ссылка</th>
          </tr>
        </thead>
        <tbody>
          {banks.map((b, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{b.name}</td>
              <td style={{ padding: 8 }}>{b.rate}</td>
              <td style={{ padding: 8 }}>{b.amount}</td>
              <td style={{ padding: 8 }}>{b.term}</td>
              <td style={{ padding: 8 }}>
                <a href={b.url} target="_blank" rel="noopener noreferrer" style={{ color: '#6366F1', textDecoration: 'none' }}>
                  Подать заявку →
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BankGuarantees;